import React from "react";
import {
    List,
    ListItemText,
    ListItemButton,
    ListSubheader,
} from "@mui/material/";
import { makeStyles } from "@mui/styles";
import styles from "./styles";
import { content } from "./content";

const StepContent = ({ id, handleNext }) => {
    const classes = makeStyles(styles)();

    return (
        <>
            <List
                className={classes.list}
                component="nav"
                aria-labelledby="nested-list-subheader"
                subheader={
                    <ListSubheader
                        component="div"
                        id="nested-list-subheader"
                        className={classes.listSubHeader}
                    >
                        {content[id].description}
                    </ListSubheader>
                }
            >
                {content[id].entries.map((item) => {
                    return (
                        <ListItemButton
                            key={item.code}
                            className={classes.listItemBtn}
                            onClick={handleNext(item.code)}
                        >
                            <ListItemText primary={item.label} />
                        </ListItemButton>
                    );
                })}
            </List>
        </>
    );
};

export default StepContent;
